import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CustomList, DocListItem } from '@/models/interfaces'
import { removeDocFromList } from '@/models/custom.lists'
import { DocsView } from '@/models/doc'

import ActionMenu from '@/app/components/ActionMenu.vue'
import Action from '@/app/components/ActionMenuItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomListDocMenu',
  props: {
    doc: null,
    docsView: null,
    list: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ActionMenu, { class: "custom-list-doc" }, {
    default: _withCtx(() => [
      _createVNode(Action, {
        class: "custom-list-doc__btn--remove",
        icon: "idelete",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(removeDocFromList)(__props.doc, __props.docsView, __props.list)), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Remove from List ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})